import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const Container = styled.div`
  padding: 40px;

  @media ${device.mobileMax} {
    padding: 0;
  }
`

export const PageTitle = styled.h3`
  margin-bottom: 20px;
  font-size: 20px;
  line-height: 20px;
  font-weight: 600;
  color: ${colors.mainText};
`

export const InfoCardsOverflow = styled.div`
  @media ${device.mobileMax} {
    position: relative;
    margin-right: 26px;
    width: 100vw;
    overflow-x: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const InfoCardsContainer = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 16px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  overflow-x: scroll;
  @media ${device.mobileMax} {
    width: 466px;
    margin-right: 26px;
  }
`

export const AlertText = styled.div`
  margin-bottom: 9px;
  display: flex;
  flex-direction: column;
`

export const AlertTitle = styled.div`
  font-weight: 600;
`

export const AlertButton = styled.button`
  background-color: transparent;
  color: ${colors.messegesRed};
  font-weight: 600;
  padding-left: 0;
  &:hover {
    color: ${colors.messegesRed};
  }
`
